import gql from 'graphql-tag';

export default gql`
  query getPublicationLogsByFolderId($folderId: Int!) {
    publication_logs(
      where: { project: { parent_folder_id: { _eq: $folderId } } }
      distinct_on: [project_id]
      order_by: [{ project_id: asc }, { published_at: desc }]
    ) {
      published_at
      page_id
      page_version_id
      user_id
      project_id
      user {
        full_name
        email
      }
      page {
        name
      }
      project {
        name
      }
    }
  }
`;
